import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  it: {
    // Landing
    welcome: "SMART INVESTIGATION",
    subtitle: "Sistema Intelligente di Raccolta Informazioni",
    startInvestigation: "Inizia Questionario Indagine",
    adminAccess: "Accesso Admin",
    selectLanguage: "Seleziona Lingua",
    
    // Privacy
    privacyTitle: "CONSENSO AL TRATTAMENTO DEI DATI",
    privacySubtitle: "Informativa Privacy GDPR",
    privacyText: `Ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003, dichiaro di aver preso visione dell'informativa sulla privacy e acconsento al trattamento dei miei dati personali per le finalità investigative richieste.

I dati forniti saranno trattati con la massima riservatezza e utilizzati esclusivamente per lo svolgimento dell'indagine richiesta. I dati saranno conservati per il tempo strettamente necessario al completamento dell'incarico e successivamente cancellati.

Il titolare del trattamento è Smart Info Srl. Per esercitare i diritti previsti dal GDPR (accesso, rettifica, cancellazione, portabilità) è possibile contattare: dpo@smart-info.it`,
    privacyLink: "Leggi l'informativa completa",
    acceptPrivacy: "Ho letto e compreso l'informativa privacy e acconsento al trattamento dei miei dati personali come descritto",
    proceedSecure: "Procedi",
    
    // Investigation Types
    selectType: "SELEZIONA TIPOLOGIA",
    selectTypeSubtitle: "Scegli il tipo di indagine",
    
    // Questionnaire
    questionnaireTitle: "RACCOLTA DATI",
    questionNumber: "Domanda",
    of: "di",
    typeAnswer: "Digita la tua risposta...",
    next: "Avanti",
    back: "Indietro",
    skip: "Salta",
    
    // Photos
    photosTitle: "CARICAMENTO FOTO",
    photosSubtitle: "Carica foto rilevanti per l'indagine",
    uploadPhoto: "Carica Foto",
    maxPhotos: "Massimo 5 foto",
    continueToSummary: "Continua al Riepilogo",
    
    // Summary
    summaryTitle: "RIEPILOGO DATI",
    summarySubtitle: "Verifica le informazioni inserite",
    submitReport: "Invia Report",
    editAnswers: "Modifica Risposte",
    
    // Thank You
    thankYouTitle: "TRASMISSIONE COMPLETATA",
    thankYouSubtitle: "Il tuo report è stato inviato con successo",
    reportId: "ID Report",
    backToHome: "Torna alla Home",
    
    // Admin
    adminLogin: "ACCESSO ADMIN",
    username: "Username",
    password: "Password",
    login: "Accedi",
    dashboard: "Dashboard",
    submissions: "Schede Inviate",
    investigationTypes: "Tipologie Indagine",
    total: "Totale",
    pending: "In Attesa",
    inProgress: "In Corso",
    completed: "Completate",
    viewDetails: "Dettagli",
    downloadPdf: "Scarica PDF",
    logout: "Esci",
    status: "Stato",
    date: "Data",
    type: "Tipo",
    actions: "Azioni",
    noSubmissions: "Nessuna scheda trovata",
    deleteConfirm: "Sei sicuro di voler eliminare questa scheda?",
    deleted: "Scheda eliminata",
    
    // Common
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    edit: "Modifica",
    add: "Aggiungi",
    close: "Chiudi",
    confirm: "Conferma",
    photos: "Foto",
    answers: "Risposte"
  },
  en: {
    // Landing
    welcome: "SMART INVESTIGATION",
    subtitle: "Intelligent Information Collection System",
    startInvestigation: "Start Investigation Questionnaire",
    adminAccess: "Admin Access",
    selectLanguage: "Select Language",
    
    // Privacy
    privacyTitle: "DATA PROCESSING CONSENT",
    privacySubtitle: "GDPR Privacy Notice",
    privacyText: `In accordance with EU Regulation 2016/679 (GDPR), I declare that I have read the privacy policy and consent to the processing of my personal data for the requested investigative purposes.

The data provided will be treated with the utmost confidentiality and used exclusively for conducting the requested investigation. Data will be retained only for the time strictly necessary to complete the assignment and subsequently deleted.

The data controller is Smart Info Srl. To exercise the rights provided by GDPR (access, rectification, deletion, portability) please contact: dpo@smart-info.it`,
    privacyLink: "Read full privacy policy",
    acceptPrivacy: "I have read and understood the privacy policy and consent to the processing of my personal data as described",
    proceedSecure: "Proceed",
    
    // Investigation Types
    selectType: "SELECT TYPE",
    selectTypeSubtitle: "Choose the investigation type",
    
    // Questionnaire
    questionnaireTitle: "DATA COLLECTION",
    questionNumber: "Question",
    of: "of",
    typeAnswer: "Type your answer...",
    next: "Next",
    back: "Back",
    skip: "Skip",
    
    // Photos
    photosTitle: "PHOTO UPLOAD",
    photosSubtitle: "Upload relevant photos for the investigation",
    uploadPhoto: "Upload Photo",
    maxPhotos: "Maximum 5 photos",
    continueToSummary: "Continue to Summary",
    
    // Summary
    summaryTitle: "DATA SUMMARY",
    summarySubtitle: "Review the entered information",
    submitReport: "Submit Report",
    editAnswers: "Edit Answers",
    
    // Thank You
    thankYouTitle: "TRANSMISSION COMPLETE",
    thankYouSubtitle: "Your report has been successfully submitted",
    reportId: "Report ID",
    backToHome: "Back to Home",
    
    // Admin
    adminLogin: "ADMIN ACCESS",
    username: "Username",
    password: "Password",
    login: "Login",
    dashboard: "Dashboard",
    submissions: "Submitted Cases",
    investigationTypes: "Investigation Types",
    total: "Total",
    pending: "Pending",
    inProgress: "In Progress",
    completed: "Completed",
    viewDetails: "Details",
    downloadPdf: "Download PDF",
    logout: "Logout",
    status: "Status",
    date: "Date",
    type: "Type",
    actions: "Actions",
    noSubmissions: "No cases found",
    deleteConfirm: "Are you sure you want to delete this case?",
    deleted: "Case deleted",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    close: "Close",
    confirm: "Confirm",
    photos: "Photos",
    answers: "Answers"
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'it';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['it'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'it' ? 'en' : 'it');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
